export function getFromLocalStorage(item) {
  const retrievedItem = window.localStorage.getItem(item)

  if (retrievedItem) { return JSON.parse(retrievedItem) }
  return null
}

export function setInLocalStorage(key, item) {
  window.localStorage.setItem(key, JSON.stringify(item))
}
